
import Api from '@/utils/api';
import MHeader from '../../Header/Header.vue';
import NotData from '../../NoData/NoData.vue';
import BuyerAddress from '../../CreateOrder/BuyerAddress.vue';
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

export default {
data() {
return {
addressInfo: null,
prize: {},
challenge: {},
nickname: '',
}
},
computed: {
},
components: {
MHeader,
Tab,
BuyerAddress,
TabItem,
Swiper,
SwiperItem,
ViewBox,
NotData,
XImg,
Confirm
},
methods: {
async goLink() {
this.$router.push({
name: 'invite-challenge',
query: {
challengeId: this.challenge._id
}
});
},
async genLink() {
if (!this.nickname) {
this.$store.commit('updateToast', {
text: '请填写昵称',
show: true
});





} else if (!this.prize._id || this.prize.status != 'ongoing') {
this.$store.commit('updateToast', {
text: '无效活动',
show: true
});
} else {
try {
const resp = await Api.post('/shops/current/member/joinInviteChallenge', {
prizeId: this.$route.query.prizeId,
nickname: this.nickname,
addressInfo: this.addressInfo
})
if (resp && resp.data && resp.data._id) {
const challengeResp = await Api.get('/shops/current/member/getInviteChallengeByPrizeId?prizeId=' + this.$route.query.prizeId)
if (challengeResp.data) {
this.challenge = challengeResp.data
}
} else {
this.$store.commit('updateToast', {
text: '失败',
show: true
});
}
} catch (e) {
if (e.response && e.response.data && e.response.data.message == 'Joined') {
this.$store.commit('updateToast', {
text: '已参加',
show: true
});
} else {
this.$store.commit('updateToast', {
text: '创建失败',
show: true
});
}
}
}
},
async getDefaultAddress() {
const defaultAddressResp = await Api.getDefaultAddress()
this.addressInfo = defaultAddressResp.data
},
async changeAddressInfo(item) {
this.addressInfo = item
if (this.challenge && this.challenge._id && !this.challenge.addressInfo) {
const challengeResp = await Api.put('/shops/current/member/updateInviteChallenge/' + this.challenge._id, {
addressInfo: this.addressInfo
})
if (challengeResp.data) {
this.challenge.addressInfo = this.addressInfo
}
}
},
},
async mounted() {
if (!this.$store.state.userInfo.mobileNumber) {
this.$router.push({
name: 'bindMobileNumber',
params: {
ref: 'prize'
}
})
this.$vux.toast.text('请绑定手机号')
}
this.nickname = this.$store.state.userInfo.nickname
const prizeResp = await Api.get('/shops/current/prizes/' + this.$route.query.prizeId)
if (prizeResp.data) {
this.prize = prizeResp.data
}
const challengeResp = await Api.get('/shops/current/member/getInviteChallengeByPrizeId?prizeId=' + this.$route.query.prizeId)
if (challengeResp.data) {
this.challenge = challengeResp.data
} else {
this.getDefaultAddress()
}
}
};



// WEBPACK FOOTER //
// ./src/components/UserCenter/invite/prize.vue